import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { WizardStepsService } from '../../../../../core/services/wizard-steps.service';
import { ForgetPasswordStepService } from '../../services/forget-password-step.service';
import { ForgetPasswordStep1Component } from './forget-password-step-1/forget-password-step-1.component';
import { ForgetPasswordStep2Component } from './forget-password-step-2/forget-password-step-2.component';
import { ForgetPasswordStep3Component } from './forget-password-step-3/forget-password-step-3.component';

@Component({
    selector: 'app-forget-password',
    templateUrl: './forget-password.component.html',
    styleUrl: './forget-password.component.scss',
    imports: [
        CommonModule,
        ForgetPasswordStep1Component,
        ForgetPasswordStep2Component,
        ForgetPasswordStep3Component,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [WizardStepsService, ForgetPasswordStepService]
})
export class ForgetPasswordComponent implements OnInit {
  constructor(public wizardStepsService: WizardStepsService) {}

  ngOnInit() {
    this.wizardStepsService.init(3);
    this.wizardStepsService.setStartingStep(1);
  }
}
